/*  TWO COLUMNS WITH IMAGE ( https://tailwindui.com/components/marketing/sections/content-sections#component-39249d619dcd4a64f3089bf550369572 )  */

import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import FluidImage from "src/utils/FluidImage";
import Button from "src/components/Button";
import GetAny from "src/utils/GetAny";
import DateAndTime from "src/utils/DateAndTime";

const TwoColumnsWithImageWebinar = ({ blok }) => {
  const customDescription =
    blok.custom_description && blok.custom_description.content[0].content;
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div
        className={`${
          blok.grey_bg ? "bg-midgrey py-9 md:py-24" : "bg-white my-9 md:my-24"
        } overflow-hidden`}
      >
        <div
          className={`relative flex flex-col md:flex-row ${
            blok.flip_content ? "md:flex-row-reverse" : ""
          } mx-auto max-w-7xl items-center px-6 sm:px-6 lg:px-8`}
        >
          {GetAny(blok.webinar).map((webinar, index) => {
            // If the start time is in the future
            let buttonText =
              webinar.content.start_time &&
              new Date(webinar.content.start_time) > new Date()
                ? "Register for webinar"
                : "Watch Webinar";
            buttonText =
              webinar.content.component === "event"
                ? "Register for event"
                : buttonText;
            return (
              <React.Fragment key={index}>
                <div
                  className={`w-full lg:w-3/5 ${
                    blok.flip_content ? "md:ml-12" : "md:mr-12"
                  }`}
                >
                  <div className="relative text-base lg:max-w-none">
                    <figure>
                      <FluidImage
                        className="object-cover object-center"
                        image={webinar.content.featured_image}
                      />
                    </figure>
                  </div>
                </div>
                <div className="w-full lg:w-2/5">
                  <div className="mt-6 mb-7 text-base md:mb-6 lg:my-0">
                    {webinar.content.start_time && (
                      <time className="font-body mb-2 block text-[0.6875em] text-[#878787]">
                        {DateAndTime(
                          webinar.content.start_time,
                          webinar.content.end_time
                        )}
                      </time>
                    )}
                    <h1
                      className={`font-display mb-2 text-4xl font-normal uppercase leading-8 tracking-tight`}
                    >
                      <RichText>{webinar.name}</RichText>
                    </h1>
                    <h3
                      className={`font-display text-red mb-4 text-2xl font-normal uppercase tracking-tight`}
                    >
                      {webinar.content.price}
                    </h3>
                  </div>
                  <div className="mt-8 lg:mt-0">
                    <div className="prose text-sm md:mx-auto md:max-w-prose lg:max-w-none">
                      <div className="text-sm text-gray-500">
                        {!customDescription && (
                          <RichText>{webinar.content.description}</RichText>
                        )}
                        {customDescription && (
                          <RichText>{blok.custom_description}</RichText>
                        )}
                      </div>
                      <Button
                        className="bg-red hover:bg-darkred mt-4 py-[20px]"
                        target={
                          blok.override_link?.cached_url
                            ? blok.override_link?.cached_url
                            : webinar.full_slug
                        }
                        blank={
                          blok.override_link?.cached_url &&
                          blok.override_link?.linktype !== "story"
                            ? true
                            : false
                        }
                      >
                        {buttonText}
                      </Button>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </SbEditable>
  );
};

export default TwoColumnsWithImageWebinar;
